import { Link } from 'react-router-dom';

const whyItemsData = [
  { icon: '🌿', label: 'Fresh Products' },
  { icon: '🛒', label: 'Wide Range' },
  { icon: '🚚', label: 'Home Delivery' },
  { icon: '🏅', label: 'FSSAI Certified' },
  { icon: '⏱️', label: 'Quick Service' },
  { icon: '🤝', label: 'Trusted Quality' },
];
const servicesData = [
  { emoji: '🥦', title: 'Fresh Groceries & Produce', desc: 'Farm-fresh vegetables and fruits sourced daily.' },
  { emoji: '🥛', title: 'Dairy & Beverages', desc: 'Milk, juices, and refreshing drinks.' },
  { emoji: '🛍️', title: 'Household & Personal Care', desc: 'All your daily essentials in one place.' },
  { emoji: '🍫', title: 'Snacks & Packaged Foods', desc: 'Snacks and packaged foods for the whole family.' },
];
const featuresData = [
  'Fast replies on WhatsApp',
  'Custom orders for events & bulk purchases',
  'Best prices guaranteed',
  'FSSAI certified products',
];
const expertiseData = [
  { icon: '🧑‍🌾', title: 'Fresh Produce', desc: 'Direct from farmers.' },
  { icon: '📦', title: 'Bulk & Wholesale', desc: 'Special pricing available.' },
  { icon: '🏠', title: 'Home Delivery', desc: 'Delivered to your door.' },
  { icon: '🌟', title: 'Quality Assurance', desc: 'Top quality products.' },
];

export function WhyUs() {
  return (
    <section id="about" className="bg-black text-white py-20 px-6 md:px-20 text-center">
      <p className="text-red-500 mb-2 font-semibold tracking-widest text-sm">WHY CHOOSE US</p>
      <h2 className="text-2xl md:text-4xl font-bold mb-12">
        The Galaxy Super Market Difference
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
        {whyItemsData.map((item, i) => (
          <div key={i} className="bg-zinc-900 border border-zinc-800 hover:border-red-800 p-6 rounded-xl hover:scale-105 transition">
            <div className="text-3xl mb-3">{item.icon}</div>
            <h4 className="font-semibold">{item.label}</h4>
          </div>
        ))}
      </div>
    </section>
  );
}

export function Services() {
  return (
    <section id="services" className="bg-black text-white py-20 px-6 md:px-20">
      <p className="text-red-500 mb-2 text-center font-semibold tracking-widest text-sm">WHAT WE OFFER</p>
      <h2 className="text-2xl md:text-4xl font-bold mb-12 text-center">
        Our Main Categories
      </h2>
      <div className="grid md:grid-cols-2 gap-6">
        {servicesData.map((s, i) => (
          <div key={i} className="bg-zinc-900 border border-zinc-800 hover:border-red-800 rounded-xl overflow-hidden transition group">
            <div className="text-5xl p-6 bg-red-900/20">{s.emoji}</div>
            <div className="p-6">
              <h3 className="text-lg font-bold mb-2">{s.title}</h3>
              <p className="text-gray-400 mb-4">{s.desc}</p>
              <a href="https://wa.me/919623969912" className="text-red-400 font-semibold group-hover:text-red-300 transition">
                Order Now →
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export function LocationBanner() {
  return (
    <section className="bg-zinc-900 border-y border-zinc-800 text-white py-12 px-6 md:px-20">
      <div className="grid md:grid-cols-3 gap-8 text-center md:text-left">
        <div>
          <h3 className="font-bold mb-2 text-red-400">Find Us in Nashik</h3>
          <p className="text-gray-400">
            Sonawane Mala, Chetana Nagar<br />
            Prashant Nagar, Pathardi Phata
          </p>
        </div>
        <div>
          <h3 className="font-bold mb-2 text-red-400">Store Hours</h3>
          <p className="text-gray-400">
            Mon – Sat: 8AM – 9PM<br />
            Sunday: 9AM – 7PM
          </p>
        </div>
        <div className="flex flex-col items-center md:items-start">
          <h3 className="font-bold mb-4 text-red-400">Visit Us Today</h3>
          <a
            href="https://maps.google.com"
            className="bg-red-500 hover:bg-red-600 transition text-white px-6 py-3 rounded-full font-semibold"
          >
            Get Directions
          </a>
        </div>
      </div>
    </section>
  );
}

export function AskUs() {
  return (
    <section className="bg-black text-white py-20 px-6 md:px-20">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div className="text-8xl text-center">🛒</div>
        <div>
          <p className="text-red-500 mb-2 font-semibold tracking-widest text-sm">ASK US ANYTHING</p>
          <h2 className="text-2xl md:text-4xl font-bold mb-4">
            Have a Query on Any Product?
          </h2>
          <p className="text-gray-400 mb-6 leading-relaxed">
            Whether you're looking for a product or bulk pricing,
            we're just a WhatsApp away.
          </p>
          <div className="space-y-3 mb-8">
            {featuresData.map((f, i) => (
              <div key={i} className="flex items-center gap-3">
                <span className="text-red-500 font-bold">✓</span>
                <span className="text-gray-300">{f}</span>
              </div>
            ))}
          </div>
          <a
            href="https://wa.me/919623969912"
            className="bg-red-500 hover:bg-red-600 transition px-7 py-3 rounded-full font-semibold inline-flex items-center gap-2"
          >
            💬 Start a Chat Now
          </a>
        </div>
      </div>
    </section>
  );
}

export function Expertise() {
  return (
    <section className="bg-black text-white py-20 px-6 md:px-20 text-center">
      <p className="text-red-500 mb-2 font-semibold tracking-widest text-sm">OUR EXPERTISE</p>
      <h2 className="text-2xl md:text-4xl font-bold mb-12">What We Do Best</h2>
      <div className="grid md:grid-cols-4 gap-6">
        {expertiseData.map((e, i) => (
          <div key={i} className="bg-zinc-900 border border-zinc-800 hover:border-red-800 p-6 rounded-xl transition">
            <div className="text-3xl mb-3">{e.icon}</div>
            <h3 className="font-bold mb-2">{e.title}</h3>
            <p className="text-gray-400 text-sm">{e.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export function WABanner() {
  return (
    <section className="bg-red-600 text-white text-center py-16 px-6">
      <h2 className="text-2xl md:text-3xl font-bold mb-3">WhatsApp Us Now</h2>
      <p className="mb-8 text-red-100">Fastest way to place orders or ask anything</p>
      <a
        href="https://wa.me/919623969912"
        className="bg-white text-red-600 px-8 py-3 rounded-full font-bold hover:bg-red-50 transition inline-block"
      >
        Chat with Us
      </a>
      <div className="mt-6 text-sm text-red-100">
        📞 9623969912 | 📧 pmdsupermarket@gmail.com
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer className="bg-black border-t border-zinc-800 text-gray-300 px-6 md:px-20 py-14">
      <div className="grid md:grid-cols-2 gap-10">
        <div>
          <img src="/logo.png" alt="Galaxy Super Market logo" className="w-16 mb-4 rounded-lg" />          <h2 className="text-white font-bold text-lg">Galaxy Super Market</h2>
          <p className="text-red-500 mb-4 text-sm font-semibold tracking-widest">FRESH · QUALITY · VALUE</p>
          <p className="text-sm text-gray-400">
            Trusted neighbourhood supermarket in Nashik offering quality groceries and essentials.
          </p>
        </div>
        <div className="md:text-right md:ml-auto max-w-sm">
          <h4 className="text-red-500 mb-4 font-bold tracking-widest text-sm">CONTACT US</h4>
          <p>📍 Prashant Nagar, Nashik</p>
          <p>📞 9028668987</p>
          <p className="mt-3">📍 Sonawane Mala, Nashik</p>
          <p>📞 9545898787</p>
          <p className="mt-3">pmdsupermarket@gmail.com</p>
          <p className="text-sm mt-2 text-gray-500">GST: 27AAZFP5671P1ZY</p>
          <p className="text-sm text-gray-500">FSSAI: 11524027000362</p>
        </div>
      </div>
      <div className="text-center text-sm mt-10 border-t border-zinc-800 pt-6 text-gray-500 flex flex-col sm:flex-row items-center justify-center gap-3">
        <span>© 2026 Galaxy Super Market | All Rights Reserved</span>
        <span className="hidden sm:inline text-zinc-700">|</span>
        <Link to="/privacy-policy" className="text-gray-500 hover:text-red-400 transition">
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}

export function WAFloat() {
  return (
    <a
      href="https://wa.me/919623969912"
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 transition w-14 h-14 flex items-center justify-center rounded-full shadow-xl"
      target="_blank"
      rel="noreferrer"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="white" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    </a>
  );
}